export type TJobType = 'VLTCalculation' | 'PlanningCalculation'

export const JobTypes: Record<TJobType, string> = {
  VLTCalculation: 'jobType.VLTCalculation',
  PlanningCalculation: 'jobType.PlanningCalculation'
};

export const JobTypesArray: TJobType[] = Object.keys(JobTypes) as TJobType[];

export default JobTypes;
